import { useEntityPanelManager } from './entity-panel-manager';
import { useWorkspaceStore } from '../../../use-workspace-store';
import { getEntityPanelSortComparator, getHistoricalPanelSortComparator } from '../utils';

export const useOpenEventPanels = (searchText: string) => {
    const eventPanelManager = useEntityPanelManager();
    const eventPanels = eventPanelManager.eventPanelsList;
    const workspacePanelsStore = useWorkspaceStore();

    const allEventWorkspacePanels = workspacePanelsStore.activePanels.filter(
        (panel) => panel.workspacePanelType === 'EVENT'
    );

    const filteredEventPanels = eventPanels
        .filter((eventPanel) => {
            if (!searchText) return true;
            const formattedSearchText = searchText.trim().toLowerCase();
            const agencyEventNumber = eventPanel.metadata?.agencyEventNumber;
            const cfsCode = eventPanel.metadata?.callForServiceCode;
            const cfsDescription = eventPanel.metadata?.callForServiceDescription;
            const panelHash = [agencyEventNumber, cfsCode, cfsDescription]
                .filter((x) => !!x)
                .join('~')
                .toLowerCase();
            return panelHash.indexOf(formattedSearchText) !== -1;
        })
        .sort(getEntityPanelSortComparator);

    const historicalEventPanels = eventPanelManager.historicalEventPanelsList;

    const filteredRecentEventPanels = historicalEventPanels
        .filter((historicalEventData) => {
            if (!searchText) return true;
            if (
                allEventWorkspacePanels.some(
                    (panel) => panel.linkedEntityId === historicalEventData.eventId
                )
            ) {
                return false;
            }
            const formattedSearchText = searchText.trim().toLowerCase();
            const agencyEventNumber = historicalEventData.agencyEventNumber;
            const cfsCode = historicalEventData.cfsCode;
            const cfsDescription = historicalEventData.cfsDescription;
            const panelHash = [agencyEventNumber, cfsCode, cfsDescription]
                .filter((x) => !!x)
                .join('~')
                .toLowerCase();
            return panelHash.indexOf(formattedSearchText) !== -1;
        })
        .sort(getHistoricalPanelSortComparator)
        .slice(0, 20);

    return {
        filteredEventPanels,
        filteredRecentEventPanels,
        allEventWorkspacePanels,
        allMonitoredEventPanels: eventPanels,
    };
};
